/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * DeleteCustomerProfilesResultDtoBase
 * auto generated base class for the model DeleteCustomerProfilesResultDtoModel.
 */
export const DeleteCustomerProfilesResultDtoModelBase = ModelBase
  .named('DeleteCustomerProfilesResultDto')
  .props({
    __typename: types.optional(types.literal("DeleteCustomerProfilesResultDto"), "DeleteCustomerProfilesResultDto"),
    deletedIds: types.union(types.undefined, types.array(types.string)),
    count: types.union(types.undefined, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DeleteCustomerProfilesResultDtoModelSelector extends QueryBuilder {
  get deletedIds() { return this.__attr(`deletedIds`) }
  get count() { return this.__attr(`count`) }
}
export function selectFromDeleteCustomerProfilesResultDto() {
  return new DeleteCustomerProfilesResultDtoModelSelector()
}

export const deleteCustomerProfilesResultDtoModelPrimitives = selectFromDeleteCustomerProfilesResultDto().deletedIds.count
